import { Box, Flex, GridItem, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { Button } from '../../../../../../components/Button';
import { FotosItem } from './FotosItem';
import { EstoqueDisponivel } from './EstoqueDisponivel';

export const ProductItem = ({ item, handleSelectProduct, productSelected }) => {
  return (
    <GridItem
      minH="351px"
      maxW="382px"
      w="full"
      border="1px solid #CFCFCF"
      display="flex"
      justifyContent="space-between"
      flexDirection="column"
      position="relative"
      fontSize="13px">
      {!item.disponivel && (
        <Flex
          position="absolute"
          px={2}
          right={0}
          top={0}
          alignItems="center"
          justifyContent="center"
          fontSize="11px"
          color="#fff"
          fontWeight="bold"
          bg="#FF0000">
          Indisponível
        </Flex>
      )}

      <Flex
        px="17px"
        py="12px"
        alignItems="center"
        borderBottom="1px solid #CFCFCF"
        fontWeight="semibold">
        {item.nome_produto} | {item.codigo_produto}
      </Flex>
      <Flex px="17px" pt="12px" flex={1}>
        <Flex gap={2}>
          <Flex
            flexDir="column"
            gap={2}
            justifyContent="space-between"
            //ocupar o espaço restante
            flex={1}>
            <FotosItem fotos={item?.img_produtos} />
            <Image
              src={item.img_home_produto}
              placeholder="https://via.placeholder.com/150"
              fallbackSrc="https://via.placeholder.com/150"
              alt={item.nome_produto}
              w="110px"
              h="143px"
              objectFit="cover"
              border="1px solid #CFCFCF"
              borderRadius="5px"
            />
          </Flex>
          <Flex flexDir="column" justifyContent="space-between" maxW="220px">
            <Text noOfLines={4}>{item.descricao}</Text>

            {item.cores?.length > 0 && (
              <Flex flexDir="column" gap={2}>
                <Text fontSize="13px" color="#378bbf">
                  Cores:
                </Text>
                <Flex alignItems="center" flexWrap="wrap">
                  {item.cores.map((item, index) => (
                    <Box
                      key={index}
                      w="12px"
                      h="12px"
                      borderRadius="50%"
                      bg={item.hex}
                      border="1px solid #CFCFCF"
                      ml="5px"
                    />
                  ))}
                </Flex>
              </Flex>
            )}
            <EstoqueDisponivel
              product={item}
              handleSelectProduct={handleSelectProduct}
              productSelected={productSelected}
            />
          </Flex>
        </Flex>
      </Flex>
      <Button
        maxW="181px"
        w="full"
        mx="auto"
        my="23px"
        bgColor={productSelected ? '#378BBF' : '#cdcdcd'}
        onClick={() => handleSelectProduct(item)}>
        {productSelected ? 'Selecionado' : 'Selecionar'}
      </Button>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        color="#2D2D2D"
        mt="auto"
        borderTop="1px solid #CFCFCF">
        <Text fontSize="11px" fontWeight="semibold" ml="17px">
          Gerado pela melhor oferta
        </Text>
        <Box h="17px" w="1px" bg="#CFCFCF" />
        <Text textTransform="uppercase" mr="17px" fontSize="12px">
          Preço site{' '}
          <Text fontSize="16px" as="span" color="#378BBF" fontWeight="bold">
            {item.preco_home}
          </Text>
        </Text>
      </Flex>
    </GridItem>
  );
};
